export const notifications_state = {
	notifications: undefined
};
